import React, { useState } from 'react';
import PricingCard from './PricingCard';
import PricingBillingToggle from './PricingBillingToggle';
import { pricingSectionCopy } from './pricingData';
import { usePublicPackages } from '../../hooks/usePublicPackages';import {
  PricingSectionShell,
  PricingSectionContainer,
  PricingTitle,
  PricingSubtitle,
  NoHiddenFeesMessage,
  PricingGrid,
} from './pricingSectionStyles';

const PricingSection = () => {
  const [billingCycle, setBillingCycle] = useState('monthly');
  const { packages } = usePublicPackages();

  return (
    <PricingSectionShell id="pricing">
      <PricingSectionContainer>
        <PricingTitle>{pricingSectionCopy.title}</PricingTitle>
        <PricingSubtitle>{pricingSectionCopy.subtitle}</PricingSubtitle>

        <NoHiddenFeesMessage>
          <span>{pricingSectionCopy.noHiddenFees}</span> {pricingSectionCopy.noHiddenFeesDetail}
        </NoHiddenFeesMessage>

        <PricingBillingToggle
          isYearly={billingCycle === 'yearly'}
          onChange={(yearly) => setBillingCycle(yearly ? 'yearly' : 'monthly')}
        />

        <PricingGrid>
          {packages.map((pkg) => (
            <PricingCard key={pkg.id} package={pkg} billingCycle={billingCycle} />
          ))}
        </PricingGrid>
      </PricingSectionContainer>
    </PricingSectionShell>
  );
};

export default PricingSection;
